/**
 * Config API - Operaciones relacionadas con configuración de usuario
 *
 * Centraliza el guardado de settings al backend y la sincronización
 * con useAuthStore para mantener consistencia.
 */

import api from './api';
import useAuthStore from '@/store/useAuthStore';

/**
 * Guarda la configuración del usuario en el backend.
 * También actualiza useAuthStore con los datos del usuario actualizados.
 *
 * @param {Object} config - Objeto de configuración (sound_enabled, music_volume, etc.)
 * @returns {Promise<Object>} Respuesta del backend con user actualizado
 */
export const saveConfigApi = async (config) => {
  const response = await api.patch('/api/user/properties', {
    properties: { config }
  });

  // Actualizar auth store con los nuevos datos del usuario
  if (response?.data?.user) {
    useAuthStore.getState().updateUserData(response.data.user);
  }

  return response;
};

/**
 * Obtiene la configuración del usuario actual desde el auth store.
 * No hace llamada API - lee del estado local.
 *
 * @returns {Object|null} Configuración del usuario o null si no está logueado
 */
export const getConfigFromUser = () => {
  const user = useAuthStore.getState().user;
  return user?.properties?.config || null;
};
